import { MainMessageType, MainMessaging, State, User } from '../../../types/state';
import { userSelector } from './user-selector';
import { createSelector } from 'reselect';
import { FilterSetup, FilterType } from '../../../types/listing/filters';
import { bulkUploadFilter, deletedFilter, importFromMIQFilter, standardFilters } from '../../../api/filters/filter-settings';
import { featureFlagSelector } from '../featureFlags/feature-flag-selector';
import { FeatureFlags } from '../../../types/state';
import { configSelector } from './config-selector';
import { Config } from '../../../types/config/config';
import { PropertyTypeOption } from '../../../types/common/option';
import { mainMessageSelector } from './main-message-selector';

export const loadingListingsSelector = (state:State) => {
    return state.pagedListings.loadingListings;
}

export const mainLoaderSelector = createSelector(
    [mainMessageSelector,
    loadingListingsSelector],
    (mainMessage:MainMessaging, loadingListings : boolean ): MainMessaging  => {
        if (loadingListings) {
            return {
                ...mainMessage,
                show: true,
                message: "Loading...",
                type: MainMessageType.LOADING
            };
        }
        return mainMessage;
    }
);